<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics" class="relative">
    <Pagesubtitle subTitle="Specify the details of social and review profiles."/>
    <div class="vx-row nofilterimags">

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Facebook" slot="no-body" class="text-center pt_sar_mid" :class="{'pt_border-danger': errors.first('Facebook page address')  }">
          <div class="text-left mt-1">           
            <vs-input
            v-model="FbSAddress"
            label="Facebook page address"
            v-validate="{url: {require_protocol: true }}"
            name="Facebook page address"
            placeholder="www.facebook.com/feedback.link"
            class="w-full mt-2"
            icon-pack="feather"
            icon="icon-facebook"
            />
            <span class="text-danger block mt-4">{{ errors.first('Facebook page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/facebookhow.png"/>
            <p class="text-sm mt-2">Copy and paste the full address (including the "https://") of your business' facebook page.</p>
              <vs-collapse type="margin" :open-hover="true" class="small" >
                <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
                  <div slot="header">
                    Why we need this?
                  </div>
                  We'll use your page address to know where to send reviewers, and to import your Facebook reviews.
                </vs-collapse-item>
              </vs-collapse>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Google Reviews" slot="no-body" class="text-center">
          <div class="mt-1 text-left">           
            <label class="vs-input--label">Google location</label>
            <p v-if="GPObject !== ''" class="my-2 font-medium">{{ GPObject.name + ', ' + GPObject.formatted_address }} <a class="purple block" href="" @click.prevent="clearGoogleMaps">X Deselect this location</a></p>
            <div id="gmapswrap">
              <div class="inner" >
                <div class="vs-con-input px-4">
                  <input id="pac-input" ref="gmsearch" type="text" maxlength="50" class="vs-inputx vs-input--input normal" placeholder="Search for your business..." style="border: 1px solid rgba(0, 0, 0, 0.2);"/>
                </div>
                <div id="map"></div>
              </div>
            </div>
            <p class="mt-2"> Business not listed? Reach out to support by clicking the (?) button.</p>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your Google profile to know where to send reviewers, and to import your Google reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>


      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex" >
        <vx-card title="X" slot="no-body" class="text-center" :class="{'pt_border-danger': errors.first('X handle') }">
          <div class="text-left mt-1">           
            <vs-input
              label="X handle"
              placeholder="getfeedbacklink"
              v-validate="'required|max:30'"
              name="X handle"
              class="w-full"
              v-model="TwAddress"
              icon-pack="feather"
              icon="icon-at-sign"
            />
            <span class="text-danger block mt-4">{{ errors.first('X handle') }}</span>
            <p class="text-sm mt-1">Type the X handle of your business.</p>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your X handle to tag your profile in posts generated.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Trustpilot" slot="no-body" class="text-center pt_sar_mid" :class="{'pt_border-danger': errors.first('Trustpilot page address') }">
          <div class="text-left mt-1" >           
            <vs-input
              v-model="TPAddress"
              v-validate="{url: {require_protocol: true }}"
              name="Trustpilot page address"
              label="Trustpilot page address"
              placeholder="https://www.trustpilot.com/review/feedbacklink"
              class="w-full"
            />
            <span class="text-danger block mt-4">{{ errors.first('Trustpilot page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/trustpilothow.png"/>
            <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Trustpilot page.</p>
          </div>   
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your Trustpilot profile to know where to send customers, and to import your Trustpilot reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>


      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Capterra" slot="no-body" class="text-center pt_sar_mid"  :class="{'pt_border-danger': errors.first('Capterra page address') }">
          <div class="text-left" >          
            <vs-input
              v-model="CTAddress"
              v-validate="{url: {require_protocol: true }}"
              name="Capterra page address"
              label="Capterra page address"
              placeholder="https://www.capterra.com/p/184192/yourbusiness"
              class="w-full"
            />
            <span class="text-danger block mt-4">{{ errors.first('Capterra page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/capterrahow.png"/>
            <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Capterra page.</p>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your Capterra profile to know where to send customers, and to import your Capterra reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Tripadvisor" slot="no-body" class="text-center pt_sar_mid"  :class="{'pt_border-danger': errors.first('Tripadvisor page address') }">
          <div class="text-left mt-1" >           
            <vs-input
              v-model="TAAddress"
              v-validate="{url: {require_protocol: true }}"
              name="Tripadvisor page address"
              label="Tripadvisor address"
              placeholder="www.tripadvisor.com/...g63810-Reviews-YourBusiness.html"
              class="w-full"
            />
            <span class="text-danger block mt-4">{{ errors.first('Tripadvisor page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/tripadvisorhow.png"/>
            <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Tripadvisor page.</p>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your Tripadvisor profile to know where to send customers, and to import your Tripadvisor reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Yelp" slot="no-body" class="text-center pt_sar_mid"  :class="{'pt_border-danger': errors.first('Yelp page address') }">
          <div class="mt-1 text-left" >           
            <vs-input
              v-model="YEAddress"
              v-validate="{url: {require_protocol: true }}"
              name="Yelp page address"
              label="Yelp address"
              placeholder="https://www.yelp.com/biz/yourbusiness"
              class="w-full"
            />
            <span class="text-danger block mt-4">{{ errors.first('Yelp page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/yelphow.png"/>
            <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' Yelp page.</p>
          </div>

          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your Yelp profile to know where to send customers, and to import your Yelp reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="Foursquare" slot="no-body" class="text-center pt_sar_mid" :class="{'pt_border-danger': errors.first('Foursquare page address') }">
          <div class="text-left mt-1" >           
            <vs-input
              v-model="FSAddress"
              v-validate="{url: {require_protocol: true }}"
              name="Foursquare page address"
              label="Foursquare address"
              placeholder="https://www.foursquare.com/v/yourbusiness/2e5f2a4"
              class="w-full"
            />
            <span class="text-danger block mt-4">{{ errors.first('Foursquare page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/foursquarehow.png"/>
            <p class="mt-1">Copy and paste the full address (including the "https://") of your business' Foursquare page. Visit <a href="https://foursquare.com/city-guide" target="_blank">The Foursquare City Guide</a> to find your Foursquare link.</p>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your Foursquare profile to know where to send customers, and to import your Foursquare reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>
    </div>

    <Savebutton submitText="Save Changes" :accept="update" :goodToGo="formReady"/>
  </div>
</template>


<script>




/*


<div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/3 mb-base flex">
        <vx-card title="G2" slot="no-body" class="text-center pt_sar_mid" :class="{'pt_border-danger': errors.first('G2 page address') }">
          <div class="mt-1 text-left">           
            <vs-input
              v-model="G2Address"
              v-validate="{url: {require_protocol: true }}"
              name="G2 page address"
              label="G2 Page Address"
              placeholder="https://www.g2.com/products/yourbusiness/reviews"
              class="w-full"
            />
            <span class="text-danger block mt-4">{{ errors.first('G2 page address') }}</span>
            <img class="w-full block mt-4" src="@/assets/images/misc/g2how.png"/>
            <p class="text-sm mt-1">Copy and paste the full address (including the "https://") of your business' G2 page.</p>
          </div>
          <vs-collapse type="margin" :open-hover="true" class="small" >
            <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
              <div slot="header">
                Why we need this?
              </div>
              We'll use your G2 profile to know where to send customers, and to import your G2 reviews.
            </vs-collapse-item>
          </vs-collapse>
        </vx-card>
      </div>


*/


function replaceDomains (a) {
  return a.replace('.co.uk/','.com/').replace('.no/','.com/').replace('.com.au/','.com/').replace('.dk/','.com/').replace('.ca/','.com/').replace('.nl/','.com/').replace('.com.in/','.com/').replace('.com.ie/','.com/').replace('.co.nz/','.com/').replace('.com.au/','.com/').replace('.de/','.com/').replace('.co.za/','.com/')
}

import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'
import Savebutton from './components/ptcomponents/Savebutton.vue'

export default {
  data () {
    return {
      switch1: true,
      setupData: false,      
      FbSAddress : null,
      FbRAddress : null,
      GPObject : null,
      TwAddress : null,
      TPAddress : null,
      G2Address : null,
      CTAddress : null,
      TAAddress : null,
      YEAddress : null,
      FSAddress : null
      }
  },
  watch: {
    FbSAddress (v) {
      this.FbRAddress = v
    },
    '$store.state.dash.currentMultiLocationI' (v) {
      if (!this._inactive) {
        this.loadGoogleMaps()
        this.initFormReady()
      }
    }
  },
  mounted () {
    this.loadGoogleMaps()
  },
  methods: {
    tac () {
      //noconsoleconsole.log(this.TAAddress)
    },
    urlWithoutExtras (url) {
      if (url === '') return ''
      let urlO = new URL(url)
      let toReturn = urlO.origin + urlO.pathname
      if(toReturn.substr(-1) === '/') {
        toReturn = toReturn.substr(0, toReturn.length - 1);
      }
      return toReturn
    },
    update () {
      if (this.formReady) {

        //noconsoleconsole.log('add'+this.FbSAddress)

        //noconsoleconsole.log(this.FbSAddress)
        //noconsoleconsole.log(this.TwAddress)
        //noconsoleconsole.log(this.TPAddress)
        //noconsoleconsole.log(this.G2Address)
        //noconsoleconsole.log(this.CTAddress)
        //noconsoleconsole.log(this.TAAddress)
        //noconsoleconsole.log(this.YEAddress)
        //noconsoleconsole.log(this.FSAddress)

        let facebookAddress = this.urlWithoutExtras(this.FbSAddress.trim()).replace('/reviews/','').replace('/reviews','')

        this.$store.dispatch('dash/UPDATE_SHARING_AND_REVIEWS', { socialMedia: {          

          //TO MAKE SURE WE GET THE REVIEWS WITHOUT PROBLEM FROM DATASHAKE, NOW ADDING /REVIEWS/
          facebook: facebookAddress !== "" ? (facebookAddress + String('/reviews')).replace('web.facebook.com','www.facebook.com') : '',
          googleMaps: typeof this.GPObject === "object" && this.GPObject !== null ? this.GPObject : '',
          twitter: this.TwAddress.trim(),
          trustPilot: this.urlWithoutExtras(this.TPAddress.trim()),
          g2: this.urlWithoutExtras(this.G2Address.trim()),
          capterra: this.urlWithoutExtras(this.CTAddress.trim()),
          tripAdvisor: replaceDomains(this.urlWithoutExtras(this.TAAddress.trim())),
          yelp: this.urlWithoutExtras(this.YEAddress.trim()),
          fourSquare: this.urlWithoutExtras(this.FSAddress.trim())

          }
        }).then(() => {
          this.$vs.notify({
            title: 'Update sharing and reviews',
            text: 'Sharing and reviews updated successfully',
            color: 'success',
            time: 6500,
            iconPack: 'feather',
            icon:'icon-check'})
            this.initFormReady()
        }).catch((e) => {
          //noconsoleconsole.log(e)
          this.$vs.notify({
            title: 'Update sharing and reviews',
            text:'Oops! Something went wrong, and we couldn\'t update your sharing and review settings. Please try again, and reach out for support if it happens again.',
            color: 'warning',
            time: 10000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        })
      }
      //REMEMBER this.initFormReady()
    },
    initFormReady () {

      if (typeof this.$refs.gmsearch !== 'undefined') {
        this.$refs.gmsearch.value = ''
      }

      
      //this.FbSAddress = this.$store.state.dash.viewData.business.publicFeedbackDetail.socialMedia.facebook

      this.FbSAddress = this.$store.state.dash.viewData.business.externalPlatforms.fb ? typeof this.$store.state.dash.viewData.business.externalPlatforms.fb.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.fb.id : '' : ''

      

      //this.FbRAddress = this.$store.state.dash.viewData.business.publicFeedbackDetail.socialMedia.facebook
      this.FbRAddress = this.FbSAddress

      this.GPObject = this.$store.state.dash.viewData.business.externalPlatforms.gp ? this.$store.state.dash.viewData.business.externalPlatforms.gp.gpObject ? this.$store.state.dash.viewData.business.externalPlatforms.gp.gpObject : '' : ''

      this.TwAddress = this.$store.state.dash.viewData.business.externalPlatforms.tw ? typeof this.$store.state.dash.viewData.business.externalPlatforms.tw.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.tw.id : '' : ''      

      this.TPAddress = this.$store.state.dash.viewData.business.externalPlatforms.tp ? typeof this.$store.state.dash.viewData.business.externalPlatforms.tp.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.tp.id : '' : ''

      this.G2Address = this.$store.state.dash.viewData.business.externalPlatforms.g2 ? typeof this.$store.state.dash.viewData.business.externalPlatforms.g2.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.g2.id : '' : ''    

      this.CTAddress = this.$store.state.dash.viewData.business.externalPlatforms.ca ? typeof this.$store.state.dash.viewData.business.externalPlatforms.ca.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.ca.id : '' : ''     

      this.TAAddress = this.$store.state.dash.viewData.business.externalPlatforms.ta ? typeof this.$store.state.dash.viewData.business.externalPlatforms.ta.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.ta.id  : '' : ''

      this.YEAddress = this.$store.state.dash.viewData.business.externalPlatforms.ye ? typeof this.$store.state.dash.viewData.business.externalPlatforms.ye.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.ye.id : '' : ''    

      this.FSAddress = this.$store.state.dash.viewData.business.externalPlatforms.fs ? typeof this.$store.state.dash.viewData.business.externalPlatforms.fs.id !== "undefined" ? this.$store.state.dash.viewData.business.externalPlatforms.fs.id : '' : ''

      this.setupData = JSON.stringify({
        FbSAddress: this.FbSAddress,
        FbRAddress: this.FbRAddress,
        GPObject: this.GPObject,
        TwAddress: this.TwAddress,
        TPAddress: this.TPAddress,
        G2Address: this.G2Address,
        CTAddress: this.CTAddress,
        TAAddress: this.TAAddress,
        YEAddress: this.YEAddress,
        FSAddress: this.FSAddress
      })
    },
    clearGoogleMaps() {
      this.GPObject = ''
      this.gmInfoWindow.close()
      this.gmMarker.setVisible(false)
      document.getElementById('pac-input').value = ''
    },
    loadGoogleMaps() {


          //commented out old functionality

          /*if (this.$route.name === 'setup'){
            this.websiteAddress = store.state.signUpState.recorded.businessInfo.webAddress
          }*/

          //let isSetup = (this.$route.name === 'setup')
          let isSetup = true //in the old panel 'setup' meant 'settings'

          //GoogleMapsApi.LIBRARIES = ['places']
          //GoogleMapsApi.KEY = 'AIzaSyA-kZ2LRZSIW-8iYAdYnbQkQr9B5uh2ISQ'
          //GoogleMapsApi.load((google) => {

            //this.googleMapsReady = true

            let googleMaps = google.maps
            let map = new googleMaps.Map(document.getElementById('map'), {
              center: {
                lat: 41.9030632,
                lng: 12.466275999999993
              },
              zoom: 2,
              clickableIcons: false,
              mapTypeControl: false,
              streetViewControl: false,
              fullscreenControl: false
            });

            let input = this.$refs.gmsearch

            let autocomplete = new googleMaps.places.Autocomplete(input, {
              types: ['establishment']
            });

            autocomplete.bindTo('bounds', map);

            map.controls[googleMaps.ControlPosition.TOP_LEFT].push(input);

            let infowindow = new googleMaps.InfoWindow();

            this.gmInfoWindow = infowindow

            let marker = new googleMaps.Marker({
              map: map
            });

            this.gmMarker = marker

            marker.addListener('click', function() {
              infowindow.open(map, marker);
            });


            if (isSetup && typeof this.$store.state.dash.viewData.business.externalPlatforms.gp === "object" && this.$store.state.dash.viewData.business.externalPlatforms.gp !== null){
              let place = this.$store.state.dash.viewData.business.externalPlatforms.gp.gpObject
              if (place){
                if (place.geometry.viewport) {
                  map.fitBounds(place.geometry.viewport);
                } else {
                  map.setCenter(place.geometry.location);
                  map.setZoom(17);
                }
                marker.setPlace({
                  placeId: place.place_id,
                  location: place.geometry.location
                });
                marker.setVisible(true);
                infowindow.setContent('<div><h4 class="">' + place.name + '</h4><p>' + place.formatted_address + '</p>');
                infowindow.open(map, marker);
              }
            }


            autocomplete.addListener('place_changed', () => {


              infowindow.close();
              let place = autocomplete.getPlace();

              if (!place.geometry) {
                return;
              }

              if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
              } else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);
              }

              // Set the position of the marker using the place ID and location.
              marker.setPlace({
                placeId: place.place_id,
                location: place.geometry.location
              });

              marker.setVisible(true);

              //noconsoleconsole.log(this)

              infowindow.setContent('<div><h2 class="purpleh2">' + place.name + '</h2><p>' + place.formatted_address + '</p>');
              infowindow.open(map, marker);


              let oldGeomLocation = { ...place.geometry.location }

              delete place.geometry
              place.geometry = {}
              place.geometry.location = {}
              place.geometry.location.lat = oldGeomLocation.lat()
              place.geometry.location.lng = oldGeomLocation.lng()
              delete place['opening_hours']
              delete place['photos']
              delete place.reviews
              delete place.adr_address

              this.GPObject = place

              /*
              HOW TO GET DETAILS OF MAPS PLACE BY PLACE ID:
              let service = new googleMaps.places.PlacesService(map);
              service.getDetails({
                placeId: place.place_id
              }, function(place, status) {
                details_container.innerHTML = '<p><strong>Status:</strong> <code>' + status + '</code></p>' +
                  '<p><strong>Place ID:</strong> <code>' + place.place_id + '</code></p>' +
                  '<p><strong>Location:</strong> <code>' + place.geometry.location.lat() + ', ' + place.geometry.location.lng() + '</code></p>' +

                  '<p><strong>Formatted address:</strong> <code>' + place.formatted_address + '</code></p>' +
                  '<p><strong>GMap Url:</strong> <code>' + place.url + '</code></p>' +
                  '<p><strong>Place details:</strong></p>' +
                  '<pre>' + JSON.stringify(place, null, " ") + '</pre>';

              });*/
            });

    }
  },
  computed: {
    formReady () {
      if (this.setupData === JSON.stringify({
        FbSAddress: this.FbSAddress,
        FbRAddress: this.FbRAddress,
        GPObject: this.GPObject,
        TwAddress: this.TwAddress,
        TPAddress: this.TPAddress,
        G2Address: this.G2Address,
        CTAddress: this.CTAddress,
        TAAddress: this.TAAddress,
        YEAddress: this.YEAddress,
        FSAddress: this.FSAddress
      })) return false
      if (this.errors.any()) return false      

      return true
    }
  },
  components: {
    Pagesubtitle,
    Savebutton
  },
  created () {
    this.initFormReady()
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */

.pt_border-danger {
  border: 1px solid red;
  box-sizing: border-box;
}

.pt_sar_mid {
  .vx-card__collapsible-content {
    height: 100%;
    min-height: 300px;
  }
  .pt_absolute_center {
    margin-top: -2rem;
  }
}


#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
